import React from 'react';

function DemoBanner() {
  return (
    <div className="bg-yellow-50 border-b border-yellow-200 px-4 py-2">
      <div className="max-w-6xl mx-auto">
        <p className="text-center text-sm font-mono text-yellow-800">
          🧪 Demo Mode: This is a demonstration environment. All data shown is synthetic.
        </p>
      </div>
    </div>
  );
}

export default DemoBanner;
